import React from "react";
import { useAuth } from "react-oidc-context";
import { jwtDecode } from "jwt-decode";

function Callback() {
  const auth = useAuth();

  if (auth.error) {
    return (
      <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
        <h2>Authentication Failed</h2>
        <p>{auth.error.message || "An unexpected error occurred."}</p>
        <p>Please try logging in again.</p>
      </div>
    );
  }

  if (!auth.isAuthenticated) {
    return (
      <div style={{ textAlign: "center", padding: "20px" }}>
        Processing login...
      </div>
    );
  }

  if (!auth.user || !auth.user.id_token) {
    return (
      <div style={{ textAlign: "center", padding: "20px", color: "red" }}>
        <h2>Invalid Token</h2>
        <p>Could not retrieve ID token. Please try logging in again.</p>
      </div>
    );
  }

  const decodedIdToken = jwtDecode(auth.user.id_token);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <h2>Works Successfully</h2>
      <div style={{ textAlign: "center", padding: "20px" }}>
        If you can view this page, it confirms that this specific connection is
        working properly. The application will receive the following user
        profile.
      </div>
      <textarea
        style={{
          width: "80%",
          height: "250px",
          padding: "15px",
          borderRadius: "10px",
          border: "1px solid #ccc",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          fontFamily: "monospace",
          fontSize: "14px",
          color: "#333",
          backgroundColor: "#f9f9f9",
          resize: "none",
          overflow: "auto",
        }}
        readOnly
        value={JSON.stringify(decodedIdToken, null, 2)}
      ></textarea>
    </div>
  );
}

export default Callback;
